import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import Button from '../components/ui/Button';
import NetworkVisual from '../components/visuals/NetworkVisual';
import TestimonialCarousel from '../components/sections/TestimonialCarousel';

const PressReleaseService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#0B0F19] min-h-screen">
      {/* Hero Section */}
      <section className="relative pt-40 pb-24 overflow-hidden border-b border-white/5">
        <NetworkVisual />
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="max-w-5xl mx-auto text-center flex flex-col items-center">
            
            <motion.h1 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="text-4xl md:text-7xl font-extrabold text-white mb-6 leading-tight tracking-tight"
            >
              Press Release <br className="hidden md:block" />
              <span className="text-purple-500">Distribution Services</span>
            </motion.h1>
            
            <motion.p 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="text-xl md:text-2xl text-slate-400 mb-12 leading-relaxed max-w-2xl mx-auto font-medium"
            >
              Increase your brand visibility and build authority with structured press release campaigns across trusted media platforms.
            </motion.p>

            {/* Trust Badges - Forced to single row on large screens */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="w-full flex flex-col items-center mb-14"
            >
              <p className="text-sm font-bold text-slate-500 uppercase tracking-widest mb-8">
                Publish your story on:
              </p>
              <div className="flex flex-wrap lg:flex-nowrap justify-center items-center gap-6 md:gap-8 lg:gap-10 opacity-60 hover:opacity-100 transition-opacity duration-500 w-full max-w-6xl">
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/22508bb601940b4e20f7d160303c50efd71c7583e6bf992668d180d798243f38c2166642d2b71e0a7892275161f0f512/images/aW1hZ2UvcG5n/b638ef3f0ad2d7b992751683d269680f.png" 
                  alt="Digital Journal" 
                  className="h-5 md:h-6 lg:h-7 object-contain" 
                />
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/22508bb601940b4e20f7d160303c50efd71c7583e6bf992668d180d798243f38c2166642d2b71e0a7892275161f0f512/images/aW1hZ2UvcG5n/989a4c9b65f6a0d7a5cb7d56d159b937.png" 
                  alt="NEWSnet" 
                  className="h-4 md:h-5 lg:h-6 object-contain" 
                />
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/22508bb601940b4e20f7d160303c50efd71c7583e6bf992668d180d798243f38c2166642d2b71e0a7892275161f0f512/images/aW1hZ2UvcG5n/7442f7578f4cee335bf8765030e8288f.png" 
                  alt="FOX 40" 
                  className="h-5 md:h-6 lg:h-8 object-contain" 
                />
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/22508bb601940b4e20f7d160303c50efd71c7583e6bf992668d180d798243f38c2166642d2b71e0a7892275161f0f512/images/aW1hZ2UvcG5n/04dfb754bd7ef8e2632ead4d51425845.png" 
                  alt="Yahoo!" 
                  className="h-5 md:h-6 lg:h-7 object-contain" 
                />
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/22508bb601940b4e20f7d160303c50efd71c7583e6bf992668d180d798243f38c2166642d2b71e0a7892275161f0f512/images/aW1hZ2UvcG5n/ce31ad070f0304aebf89c7d20ea4ad5d.png" 
                  alt="Business Insider" 
                  className="h-5 md:h-6 lg:h-7 object-contain" 
                />
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/22508bb601940b4e20f7d160303c50efd71c7583e6bf992668d180d798243f38c2166642d2b71e0a7892275161f0f512/images/aW1hZ2UvcG5n/22455314531a78bd82371a51c0c876cf.png" 
                  alt="Benzinga" 
                  className="h-5 md:h-6 lg:h-7 object-contain" 
                />
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/22508bb601940b4e20f7d160303c50efd71c7583e6bf992668d180d798243f38c2166642d2b71e0a7892275161f0f512/images/aW1hZ2UvcG5n/a116a6ca393e370b5ded3c10223543b3.png" 
                  alt="Google News" 
                  className="h-5 md:h-6 lg:h-7 object-contain" 
                />
              </div>
            </motion.div>

            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="flex justify-center w-full sm:w-auto"
            >
              <Button href="https://app.prboost.io/" variant="primary" className="!from-purple-600 !to-pink-600 !px-12 !py-5 text-xl font-bold shadow-[0_0_40px_rgba(168,85,247,0.4)] w-full sm:w-auto">
                Create an Account
              </Button>
            </motion.div>
            
          </div>
        </div>
      </section>

      {/* Video Section - Marketing that gets results! */}
      <section className="py-24 border-b border-white/5 bg-[#070b14]/30 relative overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-full bg-purple-600/5 blur-[120px] rounded-full pointer-events-none"></div>
        <div className="max-w-5xl mx-auto px-6 relative z-10">
          <div className="text-center mb-16">
            <motion.h2 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-3xl md:text-6xl font-bold text-white tracking-tight"
            >
              Marketing that gets results!
            </motion.h2>
          </div>
          
          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="aspect-video w-full rounded-2xl md:rounded-[2.5rem] overflow-hidden shadow-[0_0_60px_rgba(0,0,0,0.5)] border border-white/10 bg-black relative group"
          >
            <video
              src="/videos/press-release-explainer.mp4"
              poster="/videos/press-release-explainer.jpg"
              className="absolute inset-0 w-full h-full"
              controls
              playsInline
              preload="metadata"
              controlsList="nodownload noremoteplayback"
              disablePictureInPicture
              title="PRBOOST EXPLANATION VIDEO"
            >
              Your browser does not support the video tag.
            </video>
          </motion.div>
        </div>
      </section>

      {/* Customer Testimonials Carousel */}
      <TestimonialCarousel />

      {/* NEW: Unlock Potential Section */}
      <section className="py-24 border-b border-white/5 bg-[#070b14]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-5xl font-bold text-white mb-8 tracking-tight"
          >
            Unlock your business potential with Press Release Publication
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-lg md:text-xl text-slate-400 leading-relaxed font-medium"
          >
            From boosting visibility and credibility to driving conversions and staying ahead of the competition, our services are designed to maximize your online presence and elevate your brand to new heights. Our press release media services help maximize exposure and long-term brand growth.
          </motion.p>
        </div>
      </section>

      {/* NEW: Why use PR Boost? Section */}
      <section className="py-24 border-b border-white/5 bg-[#0B0F19]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <motion.h2 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-3xl md:text-5xl font-bold text-white mb-6 tracking-tight"
            >
              Why use PR Boost?
            </motion.h2>
            <motion.p 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="text-lg text-slate-400 max-w-3xl mx-auto leading-relaxed font-medium"
            >
              With years of experience and over 10,000 press release publications on top news sites, PRBoost delivers the media coverage your brand needs to stand out.
            </motion.p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20 max-w-6xl mx-auto">
            {/* Feature 1 */}
            <div className="flex items-start gap-5 p-6 rounded-2xl glass-card border-white/5 hover:border-white/10 transition-colors">
              <div className="w-14 h-14 rounded-xl bg-indigo-500 flex items-center justify-center flex-shrink-0 shadow-lg shadow-indigo-500/20">
                <SafeIcon icon={FiIcons.FiSearch} className="text-2xl text-white" />
              </div>
              <div>
                <h3 className="text-white font-bold text-lg mb-2">SEO experts</h3>
                <p className="text-slate-400 text-sm leading-relaxed font-medium">Our stories often outrank your competition.</p>
              </div>
            </div>

            {/* Feature 2 */}
            <div className="flex items-start gap-5 p-6 rounded-2xl glass-card border-white/5 hover:border-white/10 transition-colors">
              <div className="w-14 h-14 rounded-xl bg-amber-400 flex items-center justify-center flex-shrink-0 shadow-lg shadow-amber-400/20">
                <SafeIcon icon={FiIcons.FiHeadphones} className="text-2xl text-white" />
              </div>
              <div>
                <h3 className="text-white font-bold text-lg mb-2">Helpful support</h3>
                <p className="text-slate-400 text-sm leading-relaxed font-medium">50+ Support Guides and Live Chat support.</p>
              </div>
            </div>

            {/* Feature 3 */}
            <div className="flex items-start gap-5 p-6 rounded-2xl glass-card border-white/5 hover:border-white/10 transition-colors">
              <div className="w-14 h-14 rounded-xl bg-fuchsia-400 flex items-center justify-center flex-shrink-0 shadow-lg shadow-fuchsia-400/20">
                <SafeIcon icon={FiIcons.FiEdit3} className="text-2xl text-white" />
              </div>
              <div>
                <h3 className="text-white font-bold text-lg mb-2">Experienced writers</h3>
                <p className="text-slate-400 text-sm leading-relaxed font-medium">We write news stories that drive interest and sales.</p>
              </div>
            </div>

            {/* Feature 4 */}
            <div className="flex items-start gap-5 p-6 rounded-2xl glass-card border-white/5 hover:border-white/10 transition-colors">
              <div className="w-14 h-14 rounded-xl bg-[#0ea5e9] flex items-center justify-center flex-shrink-0 shadow-lg shadow-sky-400/20">
                <SafeIcon icon={FiIcons.FiAward} className="text-2xl text-white" />
              </div>
              <div>
                <h3 className="text-white font-bold text-lg mb-2">'As seen on' trust badge</h3>
                <p className="text-slate-400 text-sm leading-relaxed font-medium">Build trust and credibility on your website.</p>
              </div>
            </div>

            {/* Feature 5 */}
            <div className="flex items-start gap-5 p-6 rounded-2xl glass-card border-white/5 hover:border-white/10 transition-colors">
              <div className="w-14 h-14 rounded-xl bg-[#f97316] flex items-center justify-center flex-shrink-0 shadow-lg shadow-orange-500/20">
                <SafeIcon icon={FiIcons.FiLayout} className="text-2xl text-white" />
              </div>
              <div>
                <h3 className="text-white font-bold text-lg mb-2">Verified outlets</h3>
                <p className="text-slate-400 text-sm leading-relaxed font-medium">We write news stories that drive interest and sales.</p>
              </div>
            </div>

            {/* Feature 6 */}
            <div className="flex items-start gap-5 p-6 rounded-2xl glass-card border-white/5 hover:border-white/10 transition-colors">
              <div className="w-14 h-14 rounded-xl bg-[#22c55e] flex items-center justify-center flex-shrink-0 shadow-lg shadow-emerald-500/20">
                <SafeIcon icon={FiIcons.FiBarChart2} className="text-2xl text-white" />
              </div>
              <div>
                <h3 className="text-white font-bold text-lg mb-2">Industry leading reports</h3>
                <p className="text-slate-400 text-sm leading-relaxed font-medium">Includes SEO stats and Google Rankings.</p>
              </div>
            </div>
          </div>

          {/* Ratings Row */}
          <div className="flex flex-wrap justify-center items-center gap-12 md:gap-24 pt-12 border-t border-white/5">
            {/* Trustpilot */}
            <div className="text-center flex flex-col items-center">
              <div className="flex items-center gap-2 mb-3">
                <SafeIcon icon={FiIcons.FiStar} className="text-[#00b67a] text-3xl fill-[#00b67a]" />
                <span className="text-2xl font-bold text-white tracking-tight">Trustpilot</span>
                <div className="flex gap-1 ml-2">
                  {[1, 2, 3, 4, 5].map(i => (
                    <div key={i} className="w-7 h-7 bg-[#00b67a] flex items-center justify-center rounded-sm">
                      <SafeIcon icon={FiIcons.FiStar} className="text-white text-sm fill-white" />
                    </div>
                  ))}
                </div>
              </div>
              <p className="text-sm text-slate-400 font-medium">
                <strong className="text-white">Rated excellent</strong> based on 54+ reviews
              </p>
            </div>

            {/* REVIEWS.io */}
            <div className="text-center flex flex-col items-center">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-8 h-8 bg-black rounded-full flex items-center justify-center border border-white/10">
                  <SafeIcon icon={FiIcons.FiStar} className="text-white text-sm fill-white" />
                </div>
                <span className="text-2xl font-bold text-white tracking-widest">REVIEWS<span className="text-lg font-normal">.io</span></span>
              </div>
              <p className="text-sm text-slate-400 font-medium">
                <strong className="text-white">4.9 rating</strong> based on 188+ reviews
              </p>
            </div>

            {/* Product Hunt */}
            <div className="text-center flex flex-col items-center">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 bg-[#da552f] rounded-full flex items-center justify-center text-white font-bold text-xl">
                  P
                </div>
                <span className="text-xl font-bold text-[#da552f]">Product Hunt</span>
              </div>
              <p className="text-sm text-slate-400 font-medium">
                <strong className="text-white">4.9 rating</strong> based on 196+ reviews
              </p>
            </div>
          </div>

        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-32 relative overflow-hidden bg-[#070b14]">
        <div className="absolute inset-0 bg-purple-600/5 blur-[120px] rounded-full"></div>
        <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-7xl font-extrabold text-white mb-8 tracking-tighter"
          >
            Start Building Your <span className="text-purple-500 text-gradient">Brand Authority</span>
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-xl text-slate-400 mb-12 max-w-2xl mx-auto leading-relaxed"
          >
            Press releases provide a structured way to position your brand across trusted platforms and increase visibility over time. Accelerate your growth today.
          </motion.p>
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="flex justify-center"
          >
            <Button href="https://app.prboost.io/" variant="primary" className="!from-purple-600 !to-pink-600 !px-16 !py-6 text-2xl font-bold shadow-[0_0_60px_rgba(168,85,247,0.3)]">
              Create an Account
            </Button>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PressReleaseService;
